var _rect, _path, _rect2, _path2, _rect3, _ellipse, _path3, _ellipse2, _ellipse3, _ellipse4, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 62,
    viewBox: "0 0 68 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.7271,
    y: 17.1729,
    width: 47.96,
    height: 30.8621,
    rx: 7.5,
    fill: "white",
    stroke: "#736ABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8093 27.8242C38.8093 29.9973 36.892 31.8535 34.4056 31.8535C31.9193 31.8535 30.002 29.9973 30.002 27.8242C30.002 25.6512 31.9193 23.7949 34.4056 23.7949C36.892 23.7949 38.8093 25.6512 38.8093 27.8242Z",
    fill: "white",
    stroke: "#736ABD",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.252,
    y: 23.0449,
    width: 10.3074,
    height: 5.91724,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8411 27.8242C53.8411 29.9973 51.9237 31.8535 49.4374 31.8535C46.951 31.8535 45.0337 29.9973 45.0337 27.8242C45.0337 25.6512 46.951 23.7949 49.4374 23.7949C51.9237 23.7949 53.8411 25.6512 53.8411 27.8242Z",
    fill: "white",
    stroke: "#736ABD",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2837,
    y: 23.0449,
    width: 10.3074,
    height: 5.91724,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2702,
    cy: 39.4309,
    rx: 2.57684,
    ry: 1.36552,
    fill: "#736ABD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5737 19.2078V20.1628V22.5504V23.0504H18.0737H20.1529H63.3986H65.4777H65.9777V22.5504V20.1628V19.2078V18.7303V18.7078H65.9776C65.9669 17.1894 64.8784 15.8428 63.3986 15.8428H20.1529C18.673 15.8428 17.5845 17.1894 17.5738 18.7078H17.5737V18.7303V19.2078Z",
    fill: "#EFEDFF",
    stroke: "#736ABD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3169,
    cy: 19.9249,
    rx: 0.842753,
    ry: 0.886802,
    fill: "#736ABD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.1264,
    cy: 19.9249,
    rx: 0.842754,
    ry: 0.886802,
    fill: "#736ABD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.935,
    cy: 19.9249,
    rx: 0.842753,
    ry: 0.886802,
    fill: "#736ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9365 6.65726H15.7268V7.97775H10V7.01341L13.718 1.33145H10.0052V0H15.6442V0.942427L11.9365 6.65726Z",
    fill: "#736ABD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5273 12.1305H20.37V13.1209H16.0749V12.3977L18.8634 8.13619H16.0788V7.1376H20.308V7.84442L17.5273 12.1305Z",
    fill: "#736ABD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/locked-icon.2e1353897b6d745a96a37812740fe6fd.svg";
export { ForwardRef as ReactComponent };